import * as echarts from 'echarts/core'
import { BarChart, LineChart, PieChart, CustomChart, ScatterChart, EffectScatterChart, GaugeChart, RadarChart, HeatmapChart, MapChart, LinesChart, SunburstChart, TreeChart } from 'echarts/charts'
import {
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent,
  PolarComponent,
  GeoComponent,
  GraphicComponent,
  VisualMapComponent,
  RadarComponent,
  TimelineComponent,
  CalendarComponent,
  AxisPointerComponent,
  DatasetComponent
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import { RTU_ECHARTS_THEME, RTU_ECHARTS_THEME_DARK, RTU_ECHARTS_THEME_DARK_NAME, RTU_ECHARTS_THEME_NAME } from '../views/awpDashboard/rtu_ext/rtu-echarts.theme'

echarts.registerTheme(RTU_ECHARTS_THEME_NAME, RTU_ECHARTS_THEME as any)
echarts.registerTheme(RTU_ECHARTS_THEME_DARK_NAME, RTU_ECHARTS_THEME_DARK as any)

echarts.use([
  BarChart, LineChart, PieChart, CustomChart, ScatterChart,
  EffectScatterChart, GaugeChart, RadarChart, HeatmapChart, MapChart, LinesChart,
  SunburstChart, TreeChart,
  TooltipComponent, LegendComponent, TitleComponent, GridComponent,
  ToolboxComponent, DataZoomComponent, PolarComponent,
  GeoComponent, GraphicComponent, VisualMapComponent,
  RadarComponent, TimelineComponent, CalendarComponent,
  AxisPointerComponent, DatasetComponent,
  CanvasRenderer
])

export { echarts }
export { graphic } from 'echarts/core'
